import {
  VR_VERIFY_SUC,
  VR_VERIFY_ING,
  VR_VERIFY_FAIL,
  VR_VERIFY_MAKING
} from '@components/Hotel/constant'

export const VR_STATUS_LIST = {
  [VR_VERIFY_SUC]: '审核通过',
  [VR_VERIFY_FAIL]: '审核未通过',
  [VR_VERIFY_ING]: '待审核',
  [VR_VERIFY_MAKING]: '待审核'
}

export const VR_FILTER_LIST = [
  {
    value: `${VR_VERIFY_SUC},${VR_VERIFY_FAIL},${VR_VERIFY_ING},${VR_VERIFY_MAKING}`,
    text: '全部状态'
  },
  {
    value: VR_VERIFY_SUC,
    text: VR_STATUS_LIST[VR_VERIFY_SUC]
  },
  {
    value: VR_VERIFY_FAIL,
    text: VR_STATUS_LIST[VR_VERIFY_FAIL]
  },
  {
    value: `${VR_VERIFY_ING},${VR_VERIFY_MAKING}`,
    text: VR_STATUS_LIST[VR_VERIFY_ING]
  }
]

export const PAGE_SIZE = 20
